import 'twin.macro';

import { Icon, IconKey, Stack, Text, Tooltip } from '@cheqroom/ui';
import { FC, SVGProps } from 'react';

import { Location as TLocation } from '../../../../../../@types/python.d';
import { createLocationPathTooltip } from './LocationPathTooltip';
import { getIcon } from './utils';

export type LocationData = {
	_id: string;
	name: string;
	icon?: IconKey;
	fullPath?: TLocation[];
};

export const Location: FC<{ location: LocationData }> = ({ location }) => {
	const IconComponent = getIcon(location.icon, true) as FC<SVGProps<SVGSVGElement>>;

	// Show tooltip only if there's a full path with more than one location
	const tooltipContent =
		location.fullPath && location.fullPath.length > 1 ? createLocationPathTooltip(location.fullPath) : undefined;

	return (
		<Tooltip content={tooltipContent} hasArrow enabled={!!tooltipContent}>
			<div tw="flex">
				<Stack spacing="extraTight" align="center">
					<Icon source={IconComponent} size="small" tw="text-gray-400" />
					<Text tw="text-xs text-gray-500 text-ellipsis whitespace-nowrap overflow-hidden">
						{location.name}
					</Text>
				</Stack>
			</div>
		</Tooltip>
	);
};
